export const get_n = (i18next, coercePlural) => (singular, plural, count) => {
	return i18next.t(coercePlural(singular, plural, count), { count });
};
